import { z } from "zod";
/**
 * `GET /me/lifetime` — everything since the first workout, and the
 * achievements (`D204`).
 *
 * ── WHY NOT `/me/stats` ─────────────────────────────────────────────────────
 * `/me/stats` is read on every home open and every session end, and T26 made
 * it read no set at all. Every figure here is a question about sets — volume,
 * set count, distinct exercises — so it is its own read, made by Progress and
 * by the session summary, and never by Today.
 *
 * ── SERVER-COMPUTED, NEVER PUSHED ───────────────────────────────────────────
 * Each achievement is a pure function of the history: the same rows always
 * name the same session as the one that reached it, so a summary asked twice
 * names it twice, and nothing stores "already announced". Nothing here pushes
 * (`D100`, `D152`). Warm-up sets (`kind = 'warmup'`) count toward nothing.
 */
/**
 * The achievements this server can award, in the order they are listed. The
 * wire carries `achievement` as a plain string, NOT this enum: an app that
 * predates an achievement must still decode the list (`D172`) and leaves out
 * a name it has no copy for.
 */
export const ACHIEVEMENTS = [
    "early_bird",
    "night_owl",
    "weekend",
    "perfect_week",
    "explorer",
    "tonne_session",
    "tonnes_100",
];
export const achievementReached = z.object({
    /** One of {@link ACHIEVEMENTS} today; any string tomorrow. */
    achievement: z.string().min(1),
    reachedAt: z.iso.datetime(),
    /** The session that reached it — an achievement is a moment, and it links back. */
    sessionId: z.string().min(1),
});
export const lifetimeTotals = z.object({
    /** Ended workouts, abandoned ones left out (`D177`) — `/me/stats`' count. */
    sessions: z.int().nonnegative(),
    /** Working sets: every visible set of every ended session, warm-ups out. */
    sets: z.int().nonnegative(),
    /** Σ load × reps of those sets. */
    volumeKg: z.number().nonnegative(),
    /** Σ (end − start) of every ended session, rounded down once. */
    minutes: z.int().nonnegative(),
});
export const lifetimeOutput = z.object({
    totals: lifetimeTotals,
    /** Oldest first. */
    achievements: z.array(achievementReached),
});
//# sourceMappingURL=lifetime.js.map